import React from "react";
import {Link, TableColumn} from "@backstage/core-components";
import {CatalogTableRow} from "@backstage/plugin-catalog";
import SchemaEntityPage, {
  createSchemaEntityTableLinksColumn,
  getSchemaEntityTableColumns
} from "./common/SchemaEntityPage";
import {SCHEMA_CONFIG} from "./common/types";

export const createSchemaTableLinksColumn = (width?: string): TableColumn<CatalogTableRow> =>
  createSchemaEntityTableLinksColumn(SCHEMA_CONFIG, width);

export const getSchemaTableColumns = (): TableColumn<CatalogTableRow>[] =>
  getSchemaEntityTableColumns(SCHEMA_CONFIG);

export const SchemaTableSubtitle = () => {
  return (
    <>The list of schemas comes from the <Link
      to="https://github.com/weave-lab/schema">schema</Link> repository. For more information about the
      schema system, see the <Link
        to="https://switchboard.weavelab.ninja/catalog/default/component/schema-system/docs/">docs</Link>. If a
      schema's owner is listed as 'acl-developers', it is because there is no WAML that specifies that
      schema.</>
  );
};

const SchemaPage = () => <SchemaEntityPage config={SCHEMA_CONFIG}/>;

export default SchemaPage;
